import { Cancel } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { acceptHostRequestWithType } from "../../store/hostRequest/action";
import { CLOSE_HOST_TYPE_DIALOGUE } from "../../store/hostRequest/types";

// Host Type is required before a host can be approved from the Agency Panel —
// mirrors the same Audio Host / Video Host choice used in the Admin Panel and
// the same backend validation (hostRequest/acceptOrDecline).
const HostTypeDialogue = () => {
  const dispatch = useDispatch();
  const { hostTypeDialog: open, hostTypeDialogData } = useSelector(
    (state) => state.hostRequest
  );

  const [hostType, setHostType] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setHostType("");
    setError("");
    setSubmitting(false);
  }, [open]);

  const closePopup = () => {
    dispatch({ type: CLOSE_HOST_TYPE_DIALOGUE });
  };

  const handleSubmit = () => {
    if (submitting) return; // block duplicate submit

    if (!hostType) {
      return setError("Please select Audio Host or Video Host!");
    }

    if (!hostTypeDialogData?.id) {
      return setError("Request Id not found!");
    }

    setSubmitting(true);
    dispatch(acceptHostRequestWithType(hostTypeDialogData.id, hostType));
    closePopup();
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        sx={{ maxWidth: "420px", margin: "0 auto" }}
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-dark font-weight-bold h4">
            Select Host Type
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent className="mb-2">
          <div className="form-group col-12 my-3">
            <label className="mb-2 text-dark">Host Type</label>
            <select
              className="form-select form-control"
              value={hostType}
              onChange={(e) => {
                setHostType(e.target.value);
                setError(
                  e.target.value ? "" : "Please select Audio Host or Video Host!"
                );
              }}
            >
              <option value="">Select Host Type</option>
              <option value="audio">Audio Host</option>
              <option value="video">Video Host</option>
            </select>
            {error && (
              <div className="ml-2 mt-1">
                <div className="pl-1 text__left">
                  <span className="text-red">{error}</span>
                </div>
              </div>
            )}

            <div className={"pt-3"}>
              <button
                type="button"
                className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                onClick={closePopup}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-round float__right btn-danger"
                onClick={handleSubmit}
                disabled={submitting}
              >
                {submitting ? "Saving..." : "Accept"}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HostTypeDialogue;
